
import { NewPractitionerConsumption } from "../../models/Entities/Practitioners/NewPractitionerConsumption";
import { PractitionerConsumption } from "../../models/Entities/Practitioners/PractitionerConsumption";
import { PractitionerConsumptionTotal } from "../../models/Entities/Practitioners/PractitionerConsumptionTotal";
import { VisitTypeEnum } from "../../models/Enums/VisitTypeEnum";
import { ErrorType } from "../../models/HttpError";
import { PaginationState } from "../../models/PaginationState";

export const PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_REQUEST = 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_REQUEST';
export const PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_SUCCESS = 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_SUCCESS';
export const PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_FAILURE = 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_FAILURE';

export interface PractitionerConsumptionGetAllByPractitionerRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_REQUEST;
    practitionerId: string;
}

export interface PractitionerConsumptionGetAllByPractitionerSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_SUCCESS;
    practitionerId: string;
    consumptions: PractitionerConsumption[];
    paginationState: PaginationState;
}

export interface PractitionerConsumptionGetAllByPractitionerFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_FAILURE;
    practitionerId: string;
    error: ErrorType;
}

// Get practitioner consumption by id

export const PRACTITIONERCONSUMPTION_GET_BYID_REQUEST = 'PRACTITIONERCONSUMPTION_GET_BYID_REQUEST';
export const PRACTITIONERCONSUMPTION_GET_BYID_SUCCESS = 'PRACTITIONERCONSUMPTION_GET_BYID_SUCCESS';
export const PRACTITIONERCONSUMPTION_GET_BYID_FAILURE = 'PRACTITIONERCONSUMPTION_GET_BYID_FAILURE';

export interface PractitionerConsumptionGetByIdRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_GET_BYID_REQUEST;
    practitionerId: string;
    consumptionId: string;
}

export interface PractitionerConsumptionGetByIdSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_GET_BYID_SUCCESS;
    consumption: PractitionerConsumption;
}

export interface PractitionerConsumptionGetByIdFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_GET_BYID_FAILURE;
    practitionerId: string;
    consumptionId: string;
    error: ErrorType;
}

// Create practitioner consumption

export const PRACTITIONERCONSUMPTION_CREATE_REQUEST = 'PRACTITIONERCONSUMPTION_CREATE_REQUEST';
export const PRACTITIONERCONSUMPTION_CREATE_SUCCESS = 'PRACTITIONERCONSUMPTION_CREATE_SUCCESS';
export const PRACTITIONERCONSUMPTION_CREATE_FAILURE = 'PRACTITIONERCONSUMPTION_CREATE_FAILURE';

export interface PractitionerConsumptionCreateRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_CREATE_REQUEST;
    consumption: NewPractitionerConsumption;
}

export interface PractitionerConsumptionCreateSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_CREATE_SUCCESS;
    practitionerId: string;
    consumption: PractitionerConsumption;
}

export interface PractitionerConsumptionCreateFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_CREATE_FAILURE;
    practitionerId: string;
    error: ErrorType;
}

// update practitioner consumption

export const PRACTITIONERCONSUMPTION_UPDATE_REQUEST = 'PRACTITIONERCONSUMPTION_UPDATE_REQUEST';
export const PRACTITIONERCONSUMPTION_UPDATE_SUCCESS = 'PRACTITIONERCONSUMPTION_UPDATE_SUCCESS';
export const PRACTITIONERCONSUMPTION_UPDATE_FAILURE = 'PRACTITIONERCONSUMPTION_UPDATE_FAILURE';

export interface PractitionerConsumptionUpdateRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_UPDATE_REQUEST;
    consumption: PractitionerConsumption;
}

export interface PractitionerConsumptionUpdateSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_UPDATE_SUCCESS;
    consumption: PractitionerConsumption;
}

export interface PractitionerConsumptionUpdateFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_UPDATE_FAILURE;
    practitionerId: string;
    consumptionId: string;
    error: ErrorType;
}

// delete practitioner consumption

export const PRACTITIONERCONSUMPTION_DELETE_REQUEST = 'PRACTITIONERCONSUMPTION_DELETE_REQUEST';
export const PRACTITIONERCONSUMPTION_DELETE_SUCCESS = 'PRACTITIONERCONSUMPTION_DELETE_SUCCESS';
export const PRACTITIONERCONSUMPTION_DELETE_FAILURE = 'PRACTITIONERCONSUMPTION_DELETE_FAILURE';

export interface PractitionerConsumptionDeleteRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_DELETE_REQUEST;
    practitionerId: string;
    consumptionId: string;
}

export interface PractitionerConsumptionDeleteSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_DELETE_SUCCESS;
    practitionerId: string;
    consumptionId: string;
}

export interface PractitionerConsumptionDeleteFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_DELETE_FAILURE;
    practitionerId: string;
    consumptionId: string;
    error: ErrorType;
}

// Get Total 

export const PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_REQUEST = 'PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_REQUEST';
export const PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_SUCCESS = 'PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_SUCCESS';
export const PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_FAILURE = 'PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_FAILURE';

export interface PractitionerConsumptionGetTotalByStatusRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_REQUEST;
    practitionerId: string;
    status: number;
}

export interface PractitionerConsumptionGetTotalByStatusSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_SUCCESS;
    practitionerId: string;
    status: number;
    total: PractitionerConsumptionTotal[];
}

export interface PractitionerConsumptionGetTotalByStatusFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_FAILURE;
    status: number;
    practitionerId: string;
    error: ErrorType;
}

// Change status

export const PRACTITIONERCONSUMPTION_CHANGE_STATUS_REQUEST = 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_REQUEST';
export const PRACTITIONERCONSUMPTION_CHANGE_STATUS_SUCCESS = 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_SUCCESS';
export const PRACTITIONERCONSUMPTION_CHANGE_STATUS_FAILURE = 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_FAILURE';

export interface PractitionerConsumptionChangeStatusRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_STATUS_REQUEST;
    practitionerId: string;
    consumptionId: string;
    status: number;
    isForAll: boolean;
}

export interface PractitionerConsumptionChangeStatusSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_STATUS_SUCCESS;
    practitionerId: string;
    consumptionId: string;
    status: number;
    isForAll: boolean;
}

export interface PractitionerConsumptionChangeStatusFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_STATUS_FAILURE;
    practitionerId: string;
    consumptionId: string;
    status: number;
    error: ErrorType;
}

// change consumption contract concept association

export const PRACTITIONERCONSUMPTION_CHANGE_CONTRACTCONCEPT_REQUEST = 'PRACTITIONERCONSUMPTION_CHANGE_CONTRACTCONCEPT_REQUEST';
export const PRACTITIONERCONSUMPTION_CHANGE_CONTRACTCONCEPT_SUCCESS = 'PRACTITIONERCONSUMPTION_CHANGE_CONTRACTCONCEPT_SUCCESS';
export const PRACTITIONERCONSUMPTION_CHANGE_CONTRACTCONCEPT_FAILURE = 'PRACTITIONERCONSUMPTION_CHANGE_CONTRACTCONCEPT_FAILURE';

export interface PractitionerConsumptionChangeContractConceptRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_CONTRACTCONCEPT_REQUEST;
    practitionerId: string;
    consumptionId: string;
    contractConceptId: number;
}

export interface PractitionerConsumptionChangeContractConceptSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_CONTRACTCONCEPT_SUCCESS;
    practitionerId: string;
    consumptionId: string;
    updatedConsumptions: PractitionerConsumption[];
    contractConceptId: number;
}

export interface PractitionerConsumptionChangeContractConceptFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_CONTRACTCONCEPT_FAILURE;
    practitionerId: string;
    consumptionId: string;
    contractConceptId: number;
    error: ErrorType;
}

// change consumption producer 

export const PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_REQUEST = 'PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_REQUEST';
export const PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_SUCCESS = 'PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_SUCCESS';
export const PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_FAILURE = 'PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_FAILURE';

export interface PractitionerConsumptionChangeProducerRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_REQUEST;
    practitionerId: string;
    consumptionId: string;
    producerId: string;
}

export interface PractitionerConsumptionChangeProducerSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_SUCCESS;
    practitionerId: string;
    consumptionId: string;
    producerId: string;
}

export interface PractitionerConsumptionChangeProducerFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_FAILURE;
    practitionerId: string;
    consumptionId: string;
    producerId: string;
    error: ErrorType;
}

// change consumption medical service

export const PRACTITIONERCONSUMPTION_CHANGE_MEDICALSERVICE_REQUEST = 'PRACTITIONERCONSUMPTION_CHANGE_MEDICALSERVICE_REQUEST';
export const PRACTITIONERCONSUMPTION_CHANGE_MEDICALSERVICE_SUCCESS = 'PRACTITIONERCONSUMPTION_CHANGE_MEDICALSERVICE_SUCCESS';
export const PRACTITIONERCONSUMPTION_CHANGE_MEDICALSERVICE_FAILURE = 'PRACTITIONERCONSUMPTION_CHANGE_MEDICALSERVICE_FAILURE';

export interface PractitionerConsumptionChangeMedicalServiceRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_MEDICALSERVICE_REQUEST;
    practitionerId: string;
    consumptionId: string;
    medicalServiceId: number;
}

export interface PractitionerConsumptionChangeMedicalServiceSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_MEDICALSERVICE_SUCCESS;
    practitionerId: string;
    consumption: PractitionerConsumption;
}

export interface PractitionerConsumptionChangeMedicalServiceFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_MEDICALSERVICE_FAILURE;
    practitionerId: string;
    consumptionId: string;
    medicalServiceId: number;
    error: ErrorType;
}

// change amount

export const PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_REQUEST = 'PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_REQUEST';
export const PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_SUCCESS = 'PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_SUCCESS';
export const PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_FAILURE = 'PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_FAILURE';

export interface PractitionerConsumptionChangeAmountRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_REQUEST;
    practitionerId: string;
    consumptionId: string;
    amount: number;
}

export interface PractitionerConsumptionChangeAmountSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_SUCCESS;
    practitionerId: string;
    consumption: PractitionerConsumption;
}

export interface PractitionerConsumptionChangeAmountFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_FAILURE;
    practitionerId: string;
    consumptionId: string;
    amount: number;
    error: ErrorType;
}

// change rate

export const PRACTITIONERCONSUMPTION_CHANGE_RATE_REQUEST = 'PRACTITIONERCONSUMPTION_CHANGE_RATE_REQUEST';
export const PRACTITIONERCONSUMPTION_CHANGE_RATE_SUCCESS = 'PRACTITIONERCONSUMPTION_CHANGE_RATE_SUCCESS';
export const PRACTITIONERCONSUMPTION_CHANGE_RATE_FAILURE = 'PRACTITIONERCONSUMPTION_CHANGE_RATE_FAILURE';

export interface PractitionerConsumptionChangeRateRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_RATE_REQUEST;
    practitionerId: string;
    consumptionId: string;
    rate: number;
    currencyCode?: string;
    applyToSettlement: boolean;
    relatedSettlementId?: number;
}

export interface PractitionerConsumptionChangeRateSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_RATE_SUCCESS;
    practitionerId: string;
    consumption: PractitionerConsumption;
    rate: number;
    currencyCode?: string;
    applyToSettlement: boolean;
    relatedSettlementId?: number;
}

export interface PractitionerConsumptionChangeRateFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_RATE_FAILURE;
    practitionerId: string;
    consumptionId: string;
    rate: number;
    currencyCode?: string;
    applyToSettlement: boolean;
    relatedSettlementId?: number;
    error: ErrorType;
}

export const PRACTITIONERCONSUMPTION_CHANGE_TYPE_REQUEST = 'PRACTITIONERCONSUMPTION_CHANGE_TYPE_REQUEST';
export const PRACTITIONERCONSUMPTION_CHANGE_TYPE_SUCCESS = 'PRACTITIONERCONSUMPTION_CHANGE_TYPE_SUCCESS';
export const PRACTITIONERCONSUMPTION_CHANGE_TYPE_FAILURE = 'PRACTITIONERCONSUMPTION_CHANGE_TYPE_FAILURE';

export interface PractitionerConsumptionChangeTypeRequestAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_TYPE_REQUEST;
    practitionerId: string;
    consumptionId: string;
    visitType: VisitTypeEnum;
}

export interface PractitionerConsumptionChangeTypeSuccessAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_TYPE_SUCCESS;
    practitionerId: string;
    consumption: PractitionerConsumption;
}

export interface PractitionerConsumptionChangeTypeFailureAction {
    type: typeof PRACTITIONERCONSUMPTION_CHANGE_TYPE_FAILURE;
    practitionerId: string;
    consumptionId: string;
    visitType: VisitTypeEnum;
    error: ErrorType;
}

// Get all practitioner consumptions to settle
export const PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_REQUEST = 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_REQUEST';
export const PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_SUCCESS = 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_SUCCESS';
export const PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_FAILURE = 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_FAILURE';

export interface PractitionerConsumptionToSettleGetAllRequestAction {
    type: typeof PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_REQUEST;
    practitionerId: string;
}

export interface PractitionerConsumptionToSettleGetAllSuccessAction {
    type: typeof PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_SUCCESS;
    practitionerId: string;
    consumptions: PractitionerConsumption[];
}

export interface PractitionerConsumptionToSettleGetAllFailureAction {
    type: typeof PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_FAILURE;
    practitionerId: string;
    error: ErrorType;
}
